/**
 * Image generation styles offered at the AISpeachGenerator Style step.
 * Mirror of IA_STYLE from speacher_front (src/utils/ImageUtil.ts).
 *
 * `value` is a prompt suffix appended to the user's illustration prompt at
 * generation time — this is what's persisted in the store as
 * styleImageGeneration and forwarded via WeetInitiator.imageStyle.
 */
export interface AIImageStyleEntry {
  label: string;
  value: string;
}

export const LIST_OF_IMAGE_STYLES: AIImageStyleEntry[] = [
  {label: 'Stickman', value: ':: clean line art illustration, monochrome'},
  {label: 'Line Art', value: ':: clean line art illustration, monochrome'},
  {label: 'Whiteboard', value: ':: minimalist, clean composition, negative space'},
  {label: 'Blackboard', value: ':: flat design, minimal vector illustration'},
  {label: 'Flat illustration', value: ':: flat design, minimal vector illustration'},
  {label: 'Colored 2D Flat', value: ':: flat design, minimal vector illustration'},
  {label: 'Paper cut', value: ':: flat design, minimal vector illustration'},
  {label: '3D animated', value: ':: 3D render, realistic lighting and materials'},
  {label: 'Hyper realistic', value: ':: hyperrealistic, extremely detailed photograph'},
  {label: 'Cartoon 3D', value: ':: Pixar animated movie style, soft lighting, expressive characters'},
  {label: 'Craftsman / handmade', value: ':: flat design, minimal vector illustration'},
  {label: 'LEGO', value: ':: 3D render, realistic lighting and materials'},
  {label: 'Hand-drawn Anime', value: ':: Studio Ghibli hand-drawn anime art, whimsical atmosphere'},
  {label: 'Post-Impressionist', value: ':: oil painting in the style of Vincent van Gogh'},
  {label: 'Impressionist', value: ':: impressionist painting in the style of Claude Monet'},
  {label: 'Clay / stop-motion', value: ':: 3D render, realistic lighting and materials'}
];
